type WorkStoryProps = {
  story: string
}

export const WorkStory = ({ story }: WorkStoryProps) => {
  return (
    <section aria-labelledby="work-story" className="pt-16 pb-32">
      <h2 id="work-story" className="text-md font-bold">
        ストーリー
      </h2>
      <p className="mt-16">{story}</p>
    </section>
  )
}
